var IconButton                      = require("app/ui/IconButton"),
    ResubscribeFailMessage          = require("./ResubscribeFailMessage"),
    ResubscribeLoginRequiredMessage = require("./ResubscribeLoginRequiredMessage"),
    ResubscribeSuccessMessage       = require("./ResubscribeSuccessMessage"),
    ResubscribeVerificationMessage  = require("./ResubscribeVerificationMessage"),
    config                          = require("app/config"),
    frameThrottle                   = require("enyo-perf/utils").frameThrottle,
    get                             = require("object-path").get,
    icons                           = require("app/theme/icons"),
    kind                            = require("enyo/kind"),
    logger                          = require("enyo/logger");

require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.ProfilePage.ResubscribeButton.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.ResubscribeButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-profile-page-resubscribe-button",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "neutral",

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @type     {boolean}
     * @default  'false'
     * @readonly
     * @public
     */
    isSubmitting: false,

    /**
     * @private
     */
    handlers: {
        ontap:                 "ontap",
        onMessageYepButtonTap: "resubscribe"
    },

    /**
     * @private
     */
    observers: {
        update: ["isSubmitting"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update    = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.onSuccess = this.bindSafely(this.onSuccess);
            this.onFail    = this.bindSafely(this.onFail);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.authService.user", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var authService            = this.app.$.authService,
            i18nService            = this.app.$.i18nService,
            subscriptionCancelable = get(authService, "user.subscription_cancelable", false);

        this.set("caption", i18nService.getString("app.ProfilePage.ResubscribeButton.caption"));
        this.set("tooltip", i18nService.getString("app.ProfilePage.ResubscribeButton.tooltip"));

        if (this.isSubmitting) {
            this.set("icon", icons["app.ProfilePage.ResubscribeButton.submitting"]);
        }
        else {
            this.set("icon", icons["app.ProfilePage.ResubscribeButton.neutral"]);
        }
        this.addRemoveClass("loading", this.isSubmitting);

        if (get(config, "profile.allowSubscriptionModification", true)
            && authService.isLoggedIn === 1
            && get(authService, "user.status", null) === "unsubscribed"
            && subscriptionCancelable) {
            this.show();
        }
        else {
            this.hide();
        }
    },

    /**
     * Since taps could be bubbled from a popup owned by this control, we want
     * to verify the tap event's origin before handling it.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    ontap: function(sender, event) {
        var node = this.hasNode();

        if (node && node.contains(event.target)) {
            this.verifyResubscribe();
        }
    },

    /**
     * Verify the resubscribe action.
     *
     * @private
     */
    verifyResubscribe: function() {
        var message;

        // Display success message
        message = this.createComponent({
            kind: ResubscribeVerificationMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    },

    /**
     * Attempt to reactivate the subscription.
     *
     * @private
     */
    resubscribe: function() {
        var authService = this.app.$.authService;

        // Nothing to do right now.
        if (this.isSubmitting) {
            return;
        }

        // Submit form
        this.set("isSubmitting", true);
        authService
            .reactivateSubscription()
            .then(this.bindSafely(function(response) {
                switch (response.status) {
                    case "ok":
                        this.onSuccess();
                        break;
                    case "error":
                    default:
                        if (response.type === "user_not_unsubscribed") {
                            this.onSuccess();
                        }
                        else {
                            this.onFail(response.type || "unknown_error");
                        }
                        break;
                }
                this.set("isSubmitting", false);
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.onFail(error.message || "unknown_error");
                this.set("isSubmitting", false);
            }));
    },

    /**
     * User Resubscribed
     *
     * @private
     */
    onSuccess: function() {
        var message;

        // Display success message
        message = this.createComponent({
            kind: ResubscribeSuccessMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    },

    /**
     * Resubscribe failed
     *
     * @param  {string}  error  The type of error that caused the failure
     * @private
     */
    onFail: function(error) {
        var MessageKind,
            message;

        switch (error) {
            case "no_session":
                MessageKind = ResubscribeLoginRequiredMessage;
                break;
            case "order_not_found":
            case "payment_error":
            case "server_error":
            default:
                MessageKind = ResubscribeFailMessage;
                break;
        }

        // Display error message
        message = this.createComponent({
            kind: MessageKind
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    }

});
